<hs-card>
  <hs-card-body>
    @if (logo()) {
      <div class="flex flex-row gap-2 w-full justify-end items-center">
        <button
          hsIconButton
          [hsButtonColor]="'danger'"
          (click)="onDeleteLogoClicked()"
        >
          <hs-icon [innerHTML]="deleteIcon"></hs-icon>
        </button>
      </div>
      <img
        name="contact-logo"
        aria-label="contact-logo"
        alt="contact-logo"
        class="kfm-contact-logo bg-cover bg-center"
        [src]="logoContent()"
      />
    } @else {
      <div
        tabindex="0"
        role="button"
        [hsLayer]="'one'"
        class="kfm-contact-logo-empty"
        (click)="onAddFromGalleryClicked()"
      >
        <hs-icon
          [height]="80"
          [width]="80"
          name="image"
          [innerHTML]="addImageIcon"
        />
      </div>
    }
  </hs-card-body>
</hs-card>
